import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ExternalLink } from "lucide-react";

const navLinks = [
  { name: "Home", href: "#home" },
  { name: "About", href: "#about" },
  { name: "Roadmap", href: "#roadmap" },
  { name: "How to Buy", href: "#how-to-buy" },
];

const UNISWAP_URL = "https://app.uniswap.org/swap?outputCurrency=0x770dfE19F79506B724D094ad4CAC6a5dBb21F513&chain=ethereum";

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setMobileMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-white/10">
      <nav className="max-w-7xl mx-auto px-6 md:px-12 py-4 flex items-center justify-between">
        {/* Logo */}
        <a 
          href="#home" 
          onClick={(e) => scrollToSection(e, "#home")}
          className="font-heading font-black text-2xl text-[#FFD700] tracking-tight"
          data-testid="logo"
        >
          $MOJO
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => scrollToSection(e, link.href)}
              className="font-body text-sm text-[#A199AA] hover:text-[#FFD700] transition-colors uppercase tracking-wider"
              data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
            >
              {link.name}
            </a>
          ))}
          <a
            href={UNISWAP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-[#FFD700] text-[#05000A] px-4 py-2 font-bold uppercase tracking-wide text-sm hover:bg-[#FFF066] hover:-translate-y-0.5 transition-all glow-yellow"
            data-testid="buy-uniswap-btn"
          >
            Buy on Uniswap
            <ExternalLink size={14} />
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-[#FFD700]"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          data-testid="mobile-menu-btn"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden glass border-t border-white/10"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={(e) => scrollToSection(e, link.href)}
                  className="font-body text-base text-[#A199AA] hover:text-[#FFD700] transition-colors uppercase tracking-wider py-2"
                  data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {link.name}
                </a>
              ))}
              <a
                href={UNISWAP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 bg-[#FFD700] text-[#05000A] px-4 py-3 font-bold uppercase tracking-wide text-sm hover:bg-[#FFF066] transition-colors mt-2"
                data-testid="mobile-buy-uniswap-btn"
              >
                Buy on Uniswap
                <ExternalLink size={14} />
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
